<template>
<v-container>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-expansion-panels accordion   v-model="panel">
                  <v-expansion-panel key="1">
                    <v-expansion-panel-header>Wyszukiwanie</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" lg="6" md="6" sm="12">
                                <v-text-field v-model="nazwa" label="Nazwa vouchera"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" lg="6" md="6" sm="12">
                                <v-select :items="statusy" v-model="status" label="Status">
                                </v-select>
                              </v-col>
                              <v-col cols="12" lg="6" md="6" sm="12">
                                <v-checkbox v-model="nadplaty" label="Pokaż nadpłaty"></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="success" @click="getData()">Szukaj</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="vouchery"
                    :options.sync="options"
                    :server-items-length="totalCount"
                    :loading="loading"
                    :footer-props="{
                        itemsPerPageOptions:[50,100,200,500],
              }"
                    class="elevation-1"
                >
                  <template v-slot:item="props">
                    <tr>
                      <td>{{props.item.nazwa}}</td>
                      <td>{{getTypOpis(props.item)}}</td>
                      <td>{{props.item.kwota}} zł</td>
                      <td>{{props.item.waznosc_miesiace == 0 ? 'Bezterminowy' : props.item.waznosc_miesiace + ' miesiecy'}}</td>
                      <td>{{getFormattedDate(props.item.data_waznosci_system)}}</td>
                      <td>{{getWartosc(props.item)}}</td>
                      <td>{{props.item.tworca}}</td>
                      <td>{{props.item.aktywny ? 'Tak' : 'Nie'}}</td>
                      <td>
                        <v-icon small class="mr-2" @click="editVoucher(props.item.id)" v-if="$can('do','POKO_Vouchery_Edycja')" title="Edytuj voucher">fa-edit</v-icon>
                        <v-icon small class="mr-2" @click="deleteVoucher(props.item.id)" v-if="$can('do','POKO_Vouchery_Usuwanie')" title="Usuń voucher">fa-trash</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <v-dialog width="900px" v-if="showEdit" v-model="showEdit" persistent>
        <EdycjaVouchera :id="wybrany_id" @close="closedEdit"></EdycjaVouchera>
      </v-dialog>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {mapActions} from "vuex";
import {voucheryService} from "@/services/vouchery.service";
import * as dayjs from "dayjs";
import swal from "sweetalert";
import EdycjaVouchera from "@/components/vouchery/EdycjaVouchera";

export default {
  name: "ListaVoucherow",
  components: {EdycjaVouchera},
  props: ["szukanynumer"],
  data() {
    return {
      loading: false,
      totalCount: 0,
      vouchery:[],
      options: {},
      showEdit: false,
      wybrany_id: 0,
      panel: -1,
      statusy: [
        { text: 'Aktywne', value: 1 },
        { text: 'Nieaktywne', value: 2 },
        { text: 'Wszystkie', value: 0}
      ],
      status: 1,
      nazwa: '',
      numer: '',
      nadplaty: false,
      headers: [
        {text: 'Nazwa vouchera',  align: 'left', value: 'nazwa'},
        {text: 'Typ vouchera', align: 'left', value:'typ'},
        {text: 'Cena',  align: 'left', value: 'kwota'},
        {text: 'Ważność vouchera dla klienta', align: 'left', value: 'waznosc_miesiace'},
        {text: 'Ważnośc vouchera w systemie', align: 'left', value: 'data_waznosci_system'},
        {text: 'Wartość', align: 'left', value: 'id'},
        {text: 'Twórca', align: 'left',value: 'tworca'},
        {text: 'Aktywny', align: 'left', value: 'aktywny'},
        {text: 'Akcje', align: 'left', value: 'id'},
      ],
    }
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    closedEdit() {
      this.showEdit = false
      this.getData()
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      this.loading = true
      voucheryService.getAll({
        Sorting: sortValue,
        status: this.status,
        nazwa: this.nazwa,
        numer: this.numer,
        nadplaty: this.nadplaty,
        SkipCount: (page-1) * itemsPerPage,
        MaxResultCount: itemsPerPage
      }).then(result => {
        this.vouchery = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(()=> {
        this.error('Błąd pobierania voucherów.')
        this.loading = false
      })
    },
    getFormattedDate(val)
    {
      if(val == null)
      {
        return 'Bezterminowy'
      }
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY")
      }
      else
      {
        return val
      }
    },
    editVoucher(id)
    {
      this.wybrany_id = id
      this.showEdit = true
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    deleteVoucher(id)
    {
      this.loading = true
      voucheryService.deleteVoucher(id).then(resp=> {
        this.getData()
      }).catch(resp => {
        if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
        ) {
          this.showError( resp.response.data.error.message);
        } else {
          this.showError("Nie można usunąć vouchera");
        }
        this.loading = false
      })

    },
    getTypOpis(item)
    {
      switch(item.typ)
      {
        case 0:
          return 'Wizyta';
        case 1:
          return 'Czas';
        case 2:
          return 'Kwota';
      }
      return ''
    },
    getWartosc(item)
    {
      switch(item.typ)
      {
        case 0:
          return item.ilosc_wizyt+ ' wizyt';
        case 1:
          return item.czas_minuty+ ' minut';
        case 2:
          return item.kwota_do_wykorzystania+ ' zł';
      }
      return ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
}
</script>

<style scoped>

</style>
